import { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from "react-redux";

import { filterTestsThunk, setIsLoading } from '../../store/tests';
import { getCategories } from '../../utils/api';

import MenuContext from '../../store/MenuContext';
import CategoryMenuClasses from './CategoryMenu.module.css';

const Categories = (props) => {
	const menuTheme = useContext(MenuContext);
    const testsState = useSelector(state => state.tests);
    const dispatch = useDispatch();
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        async function fetchCategories() {
            const fetchedCategories = await getCategories('0');
            setCategories(fetchedCategories);
        }

        fetchCategories();
    }, []);

    const toggleCategoriesHandler = (event) => {
        dispatch(setIsLoading());
        dispatch(filterTestsThunk(event.target.value,0));
    }

    const categoriesList = categories.map((category) => {
        const elementID = `${props.idPrefix}_${category.ID}`;

        return (
            <div key={category.ID} className={CategoryMenuClasses.categoryItem}>
                <input type='checkbox' id={elementID} name='category' value={category.ID} checked={testsState.categories.includes(category.ID)} onChange={toggleCategoriesHandler}/>
                <label htmlFor={elementID}>{category.Name}</label>
            </div>
        );
    });

    return (
        <div className={CategoryMenuClasses.categories}>
            <h1 className={CategoryMenuClasses.title}>Categories</h1>
            {categoriesList}
        </div>
    );
};

export default Categories;